import classNames from 'classnames';
import useLayout from 'hooks/use-layout';
import type { ReactNode } from 'react';
import type { Layout } from 'types/layout';
import { validateString } from 'utils/validate-string';

import styles from './header.module.scss';

interface Props {
  readonly media?: ReactNode | undefined;
  readonly backgroundImage?: ReactNode | undefined;
  readonly layout: Layout;
  readonly heading?: ReactNode | undefined;
  readonly decorativeHeading?: ReactNode | undefined;
}

interface State {
  readonly rootClass: string;
  readonly contentClassName: string;
  readonly resolvedLayout: Layout;
}

const centerClass = validateString(styles.center);
const contentWrapperClass = validateString(styles.contentWrapper);
const contentOverBackgroundClass = validateString(styles.contentOverBackground);

export default function useHeader({
  backgroundImage,
  layout,
  media,
}: Props): State {
  const layoutClass = useLayout({
    layout,
    styles,
  });

  const resolvedLayoutClass =
    typeof media === 'undefined' ? centerClass : layoutClass;

  return {
    rootClass: classNames(resolvedLayoutClass),
    contentClassName: classNames(contentWrapperClass, resolvedLayoutClass, {
      [contentOverBackgroundClass]: typeof backgroundImage !== 'undefined',
    }),
    resolvedLayout: typeof media === 'undefined' ? 'center' : layout,
  };
}
